import DocumentList from './components/DocumentList';
import DocumentShow from './components/DocumentShow/DocumentShow';

export default [
  {
    key: 'list',
    component: DocumentList,
    path: '/documents',
    public: false,
  },
  {
    key: 'show',
    component: DocumentShow,
    path: '/documents/:id',
    public: false,
  },
];